module.exports = __webpack_public_path__ + "img/Ivan-Cupic.9a8ae7f5.jpeg";